import { Component, HostBinding, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'app-input-footer',
  templateUrl: './input-footer.component.html',
  styleUrls: ['./input-footer.component.scss']
})
export class InputFooterComponent implements OnInit, OnChanges {
  @Input() hint?: string | null;
  @Input() control?: AbstractControl | null;

  @HostBinding('class') class = '';

  constructor() {}

  ngOnInit(): void {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.hint) this.class = changes.hint.currentValue ? 'with-hint' : '';
  }
}
